import { Link } from "react-router-dom";
import { Heart, ShoppingBag, User } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import { CART, ACCOUNT } from "@/constants/testIds";

const icon = "relative w-10 h-10 rounded-full grid place-items-center hover:bg-[#F0EBE1] transition-colors";

export const NavIcons = () => {
  const { count } = useCart();
  const { user } = useAuth();
  return (
    <div className="flex items-center gap-1">
      <Link to="/favorites" data-testid={ACCOUNT.navFavorites} aria-label="Favorites" className={`${icon} hidden sm:grid`}><Heart size={19} /></Link>
      <Link to="/account" data-testid={ACCOUNT.navButton} aria-label="Account" className={icon}>
        {user?.picture ? <img src={user.picture} alt="" className="w-7 h-7 rounded-full" /> : <User size={19} />}
      </Link>
      <Link to="/cart" data-testid={CART.navButton} aria-label="Cart" className={icon}>
        <ShoppingBag size={19} />
        {count > 0 && (
          <span data-testid={CART.navCount} className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[#E06D44] text-white text-[10px] font-bold grid place-items-center">{count}</span>
        )}
      </Link>
    </div>
  );
};
